export var roundPerfNow = function roundPerfNow() {
  return ~~performance.now();
};